<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  @if (!trackingDetailsIsEmpty) {
    <div>
      @if (latestDetails) {
        <div>
          <div class="py-2">
            <mat-divider></mat-divider>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h1 mat-card-title>
                {{latestDetails.tracking.eventCodeDescription}}
              </h1>
            </div>
            <div class="col-md-6">
              <h3>
                <span class="faded-text me-2">Date:</span>
                {{utilService.bestBeforeTime(latestDetails.tracking.dateAndTime)}}
              </h3>
              <h3>
                <span class="faded-text me-2">Delivery date:</span>
                {{utilService.bestBeforeTime(latestDetails.tracking.deliveryDate)}}
              </h3>
              <h3>
                <span class="faded-text me-2">Waybill number:</span> {{latestDetails.tracking.waybillNo ?
                latestDetails.tracking.waybillNo: "-"}}
              </h3>
            </div>
            <div class="col-md-6">
              <h3>
                <span class="faded-text me-2">From branch:</span> {{latestDetails.tracking.Branch ?
                latestDetails.tracking.Branch: "-"}}
              </h3>
              <h3>
                <span class="faded-text me-2">To branch:</span> {{latestDetails.tracking.toBranch ?
                latestDetails.tracking.toBranch: "-"}}
              </h3>
              <h3>
                <span class="faded-text me-2">Delivered to:</span> {{latestDetails.tracking.deliveredTo ?
                latestDetails.tracking.deliveredTo : "-"}}
              </h3>
            </div>
          </div>
          <div class="py-2">
            <mat-divider></mat-divider>
          </div>
        </div>
      }
      <mat-accordion [@.disabled]="true">
        @for (details of trackingDetails; track details) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon inline class="me-2">event</mat-icon> <span
                class="me-2">{{utilService.bestBeforeTime(details.tracking.dateAndTime)}} <span
              class="mx-2">-</span></span>
              <span>{{details.tracking.eventCodeDescription}}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="details">
            <table>
              <tr>
                <th>Waybill number</th>
                <td>{{details.tracking.waybillNo ? details.tracking.waybillNo : "-"}}</td>
              </tr>
              <tr>
                <th>Description</th>
                <td>{{details.tracking.eventCodeDescription ? details.tracking.eventCodeDescription : "-"}}</td>
              </tr>
              <tr>
                <th>From branch</th>
                <td>{{details.tracking.Branch ? details.tracking.Branch : "-"}}</td>
              </tr>
              <tr>
                <th>To branch</th>
                <td>{{details.tracking.toBranch ? details.tracking.toBranch : "-"}}</td>
              </tr>
              <tr>
                <th>Sender reference</th>
                <td>{{details.tracking.sendersRef ? details.tracking.sendersRef : "-"}}</td>
              </tr>
              <tr>
                <th>Delivered to</th>
                <td>{{details.tracking.deliveredTo ? details.tracking.deliveredTo : "-"}}</td>
              </tr>
              <tr>
                <th>Delivery date</th>
                <td>{{utilService.bestBeforeTime(details.tracking.deliveryDate)}}</td>
              </tr>
              <tr>
                <th>Event code</th>
                <td>{{details.tracking.eventCode ? details.tracking.eventCode : "-"}}</td>
              </tr>
              <tr>
                <th>Code</th>
                <td>{{details.tracking.code ? details.tracking.code : "-"}}</td>
              </tr>
              <tr>
                <th>Additional information</th>
                <td>{{details.tracking.additionalText ? details.tracking.additionalText : "-"}}</td>
              </tr>
            </table>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
}

@if (trackingDetailsIsEmpty) {
  <div class="no-tracking">
    <div>
      <h1 class="faded-text">No tracking events found</h1>
    </div>
  </div>
}

</div>
<div mat-dialog-actions align="end">

  <button class="me-2" (click)="refresh()" mat-stroked-button>
    <mat-icon>refresh</mat-icon>
  </button>

  <button mat-raised-button [mat-dialog-close]="false">Close</button>
</div>